import { render, staticRenderFns } from "./AttachLotsModal.vue?vue&type=template&id=5fca1915&scoped=true"
import script from "./AttachLotsModal.vue?vue&type=script&lang=js"
export * from "./AttachLotsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca1915",
  null
  
)

export default component.exports